import { useTranslation } from 'react-i18next'
import { EntityHistoryHeader } from '@/components/entity-history/EntityHistoryHeader'
import { Button } from '@/components/ui/button'
import { useCaseAsOf } from '@/features/case-as-of/CaseAsOf'
import { toHeaderView } from './summary-view'
import { useEntitySummary } from './useEntitySummaries'

export function EntityHistoryPreview({
  caseId,
  uid,
  onOpenHistory,
}: {
  caseId: string
  uid: string | null
  onOpenHistory: () => void
}) {
  const { t } = useTranslation()
  const { asOf } = useCaseAsOf()
  const summary = useEntitySummary(caseId, uid, asOf)
  if (!uid) return null
  return (
    <div className="space-y-1">
      {summary.data && (
        <EntityHistoryHeader
          view={toHeaderView(summary.data, asOf ? new Date(asOf) : new Date())}
          compact
        />
      )}
      <Button variant="link" size="sm" className="h-auto px-0" onClick={onOpenHistory}>
        {t('investigations.entityDetail.history.openHistory')}
      </Button>
    </div>
  )
}
